import React from 'react';
import Button from '@mui/material/Button';
import type { ButtonProps } from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { customButtonPalette } from '../../theme/palette.ts';

export interface NavLinkType {
  label: string;
  path: string;
}

export interface RoundedButtonLinkProps extends ButtonProps {
  navLink: NavLinkType;
  variantStyle: 'light' | 'dark';
  variant: ButtonProps['variant'];
}

const RoundedButtonLink: React.FC<RoundedButtonLinkProps> = ({
  navLink,
  variantStyle,
  variant,
  ...rest
}) => {
  const buttonStyling = customButtonPalette[variantStyle];

  return (
    <Button
      component={Link}
      to={navLink.path}
      variant={variant}
      disableElevation
      sx={{
        backgroundColor: buttonStyling.backgroundColor,
        color: buttonStyling.color,
        borderRadius: '20px',
        padding: '8px 24px',
        '&:hover': {
          backgroundColor: buttonStyling.backgroundColor,
          color: buttonStyling.color,
        },
      }}
      role="button"
      data-testid={`nav-link-${navLink.label.replace(/\s+/g, '-').toLowerCase()}`}
      {...rest}
    >
      {navLink.label}
    </Button>
  );
};

export default RoundedButtonLink;
